import { z } from 'zod';
export var CommunicationOutsideWindowBehavior;
(function (CommunicationOutsideWindowBehavior) {
    CommunicationOutsideWindowBehavior["Skip"] = "Skip";
    CommunicationOutsideWindowBehavior["Queue"] = "Queue";
})(CommunicationOutsideWindowBehavior || (CommunicationOutsideWindowBehavior = {}));
export var CommunicationWeekday;
(function (CommunicationWeekday) {
    CommunicationWeekday["Sunday"] = "Sunday";
    CommunicationWeekday["Monday"] = "Monday";
    CommunicationWeekday["Tuesday"] = "Tuesday";
    CommunicationWeekday["Wednesday"] = "Wednesday";
    CommunicationWeekday["Thursday"] = "Thursday";
    CommunicationWeekday["Friday"] = "Friday";
    CommunicationWeekday["Saturday"] = "Saturday";
})(CommunicationWeekday || (CommunicationWeekday = {}));
/**
 * CommunicationWindowSchema defines when communications are allowed.
 *
 * Time Range Semantics:
 * - Start time is INCLUSIVE - communications can begin at this exact time
 * - End time is EXCLUSIVE - communications must complete before this time
 *   (e.g., end={hours:9, minutes:0} means communications stop at 08:59:59.999)
 * - If end time is before start time, the window wraps to the next day
 *   (e.g., start={hours:22, minutes:0}, end={hours:6, minutes:0} means 10pm-6am)
 * - If end time equals start time, the window wraps to the next day
 *   (e.g., start={hours:0, minutes:0}, end={hours:0, minutes:0} means a full 24-hour window)
 */
export const CommunicationWindowSchema = z.object({
    daysOfWeek: z
        .array(z.enum(CommunicationWeekday))
        .optional()
        .default([
        CommunicationWeekday.Monday,
        CommunicationWeekday.Tuesday,
        CommunicationWeekday.Wednesday,
        CommunicationWeekday.Thursday,
        CommunicationWeekday.Friday,
    ]),
    timeRange: z
        .object({
        start: z.object({
            hours: z.number().int().min(0).max(23).default(0),
            minutes: z.number().int().min(0).max(59).default(0),
        }),
        end: z.object({
            hours: z.number().int().min(0).max(23).default(0),
            minutes: z.number().int().min(0).max(59).default(0),
        }),
    })
        .optional(),
    timeZone: z
        .string()
        .optional()
        .default('UTC')
        .refine((timeZone) => {
        try {
            Intl.DateTimeFormat(undefined, { timeZone });
            return true;
        }
        catch {
            return false;
        }
    }, { message: 'Invalid IANA time zone identifier' }),
    outsideWindowBehavior: z
        .enum(CommunicationOutsideWindowBehavior)
        .optional()
        .default(CommunicationOutsideWindowBehavior.Skip),
});
//# sourceMappingURL=window.js.map